(function($) {
	'use strict';
	$.widget('msv.uploadFile', {
		vars: {},
		el: {},
		_create: function() {
			var self = this;
			self.vars.labelText = self.element.data('label');
			self.vars.nameAttr = self.element.data('name');
			self.vars.endpoint = self.element.data('endpoint');
			self.vars.ruleRequired = self.element.data('rule-required');
		},
		_init: function() {
			var self = this;
			var inputName = self.vars.nameAttr ? " name='" + self.vars.nameAttr + "'" : "";
			self.el.uploadButton = $('<a class="btn btn-gray">' + self.vars.labelText + '</a>');
			var requiredStr = self.vars.ruleRequired ? "data-rule-required=\"true\"" : "";
			self.el.input = $('<input type=file style="display:none" class="spacer-medium" ' + requiredStr + '>');
			self.el.inputHidden = $('<input type=hidden ' + inputName + '>')
			self.el.spanFileName = $('<span></span>');
			self.element.html(self.el.uploadButton);
			self.element.append(self.el.input);
			self.element.append(self.el.spanFileName);
			self.element.append(self.el.inputHidden);


			self.el.uploadButton.off('click').click(function() {
				self.el.input.trigger('click');
			});

			self.el.input.change(function() {
				//--- Create data to ajax
				var file = this.files[0];
				var data = new FormData();
				data.append(file.name, file);

				//--- Loading Button
				self.el.uploadButton.attr('disabled', true).addClass('btn-loading');
				self.el.uploadButton.append("<span class='btn-loading-spinner'></span>");

				//--- Reset input
				self.el.spanFileName.html('');
				self.el.inputHidden.val('');

				//--- ajax request
				var ajaxRequest = $.ajax({
					type: "POST",
					url: self.vars.endpoint,
					contentType: false,
					processData: false,
					data: data,
					success: function(response) {
						self.el.uploadButton.attr('disabled', false).removeClass('btn-loading');
						self.el.uploadButton.find(".btn-loading-spinner").remove();
						self.el.inputHidden.val(response);
						self.el.spanFileName.html(self.el.input.val().split('\\').pop())
					}
				});
			});
		},
		_destroy: function() {

		}
	});
})(jQuery);